import React from 'react';
import { compose } from 'ramda';
import { withProps } from 'recompose';
import { withTranslations } from 'js/components/hocs/withTranslations';
import { Button } from 'js/components/common/Button';
import useJoinLeaveButtonProps from '../useJoinLeaveButtonProps';
import style from './index.scss';

export const LeaveButton = ({ t, onClick, disabled }) => (
    <Button
        view="secondary"
        variant="rounded"
        color="negative"
        size="large"
        onClick={onClick}
        disabled={disabled}
        className={style.button}>
        {t('playtech.mobile.system.leaderboard.button.leaveRace')}
    </Button>
);

export default compose(
    withTranslations,
    withProps(
        ({ leaderboardId }) => {
            const { onClick, disabled } = useJoinLeaveButtonProps('leave')({ leaderboardId });

            return {
                onClick,
                disabled
            };
        }
    )
)(LeaveButton);
